import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "brand",
  ref: "readMarker"
}
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col-3 p-d-flex p-justify-center p-pt-6" }
const _hoisted_4 = { class: "p-col-7" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", null, "Brand Name", -1)
const _hoisted_6 = { class: "p-text-bold" }
const _hoisted_7 = { class: "p-mt-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h6", null, "Brand Description", -1)
const _hoisted_9 = { class: "text-pre-line" }
const _hoisted_10 = {
  key: 0,
  class: "actions p-col-2 p-d-flex p-justify-end p-align-start"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", { class: "separator" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h6", null, "Brand Campaigns", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditBrandModal = _resolveComponent("EditBrandModal")!
  const _component_BrandPhoto = _resolveComponent("BrandPhoto")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CampaignsList = _resolveComponent("CampaignsList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_EditBrandModal, {
      show: _ctx.showEditBrandModal,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showEditBrandModal) = $event)),
      brand: _ctx.brand,
      working: _ctx.controller.manager.updatingInProgress.value,
      onSave: _ctx.updateBrand
    }, null, 8, ["show", "brand", "working", "onSave"]),
    (_ctx.brand)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_BrandPhoto, {
                brand: _ctx.brand,
                class: "brand-photo"
              }, null, 8, ["brand"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _hoisted_5,
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.brand.name), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.brand.description), 1)
              ])
            ]),
            (_ctx.brand.isOwnedByMe())
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_Button, {
                    label: "Edit Brand",
                    class: "p-button-link action-edit",
                    icon: "pi pi-pencil",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEditBrandModal = true))
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_11,
          _hoisted_12,
          _createVNode(_component_CampaignsList, {
            campaigns: _ctx.brand.campaigns.filter((c) => c.status === 'active') || [],
            class: "campaigns-list"
          }, null, 8, ["campaigns"])
        ], 512))
      : _createCommentVNode("", true)
  ]))
}